import { Info } from "lucide-react";

// The engine rejects any request that resolves to more than this many tools
// (directors `max_tools`), so warn as a gateway's tool set reaches that ceiling.
const TOOLSET_NOTICE_THRESHOLD = 64;

export function ToolsetNotice({
  count,
  toolSearchActive = false,
}: {
  count: number;
  /** With tool search on, the agent fetches tools on demand, so a large set is
   * fine — the "keep it focused" nudge doesn't apply. */
  toolSearchActive?: boolean;
}) {
  if (toolSearchActive || count < TOOLSET_NOTICE_THRESHOLD) {
    return null;
  }

  return (
    <div className="flex items-start gap-2 rounded-md border border-warning/30 bg-warning/5 px-3 py-2 text-sm">
      <Info aria-hidden className="mt-0.5 size-4 shrink-0 text-warning" />
      <p className="text-muted-foreground leading-snug">
        Keep this focused. Agents work best when they only see the apps and
        tools they need for the job. Large tool sets take more context to
        describe and can make tool choice less reliable.
      </p>
    </div>
  );
}
